"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateFormSettingsRequestStatus = exports.getFetchFormSettingsRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getFetchFormSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.FormSettingsActionType.FETCH_FORM_SETTINGS);
exports.getFetchFormSettingsRequestStatus = getFetchFormSettingsRequestStatus;
var getUpdateFormSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.FormSettingsActionType.UPDATE_FORM_SETTINGS);
exports.getUpdateFormSettingsRequestStatus = getUpdateFormSettingsRequestStatus;